module.exports = __webpack_public_path__ + "static/media/recurring.8eea6e82.svg";